import React, {useState, useEffect} from 'react';
import errors from '../Errors/errors';
import CompletedSuccessfulComponent from './CompletedSuccessfulComponent';
import ErrorComponent from '../Errors/ErrorComponent';
import FamilyErrorComponent from '../Errors/FamilyErrorComponent';
import CellcomDuErrorComponent from '../Errors/CellcomDuErrorComponent';
import { stepEnum } from '../ChangePricePlanConsts';

const CompletedComponent = ({props, startOver, backToPrivateArea}) => {
  const [errorPage, setErrorPage] = useState(false);
  const [familyErrorPage, setFamilyErrorPage] = useState(false);
  const [cellcomDu, setCellcomDuErrorPage] = useState(false);

  useEffect(() => {
    if (props.data.error) {
      if (props.data.failReasonCode == 'not allowed') {
        setFamilyErrorPage(true);
      } else if (props.data.failReasonCode == 'cellcomDu') {
        setCellcomDuErrorPage(true);
      } else {
        if (props.data.succeededNumbers == null && props.data.unSucceededNumbers == null) {
          if (props.data.failReasonCode == '10') {
            props.setError({text: errors.the_same_plan, reason: 'the_same_plan'});
          } else {
            props.setError({text: errors.error_on_change, reason: 'error_on_change'});
            props.handleCurrentStep({step: stepEnum.CALL_BACK, error: true});
          }
        } else {
          const succeededNumbers = props.data.succeededNumbers.map((num, index) => {
            num = num.replace(/^(.{3})(.*)$/, '$1-$2');
            let comma = index + 1 == props.data.succeededNumbers.length ? '' : ',';
            return `<span className="completed-phone-number">${num + comma}</span>`;
          });

          const textWithPhoneNumbers = errors.error_failed_part_of.description.replace('phone_numbers', succeededNumbers.join(' '));
          const error_obj = {...errors.error_failed_part_of, description: textWithPhoneNumbers};

          props.setError({text: error_obj, reason: 'error_failed_part_of'});
        }
        setErrorPage(true);
      }
    }

    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
  }, []);

  function getErrorPage() {
    if (familyErrorPage) {
      return <FamilyErrorComponent props={props} />;
    } else if (cellcomDu) {
      return <CellcomDuErrorComponent props={props} />;
    } else {
      return (
        <div className='justify-content-center'>
          {!errorPage && !props.data.error && <CompletedSuccessfulComponent props={props} backToPrivateArea={backToPrivateArea} />}
          {errorPage && props.data.error && (
            <ErrorComponent
              props={props.data}
              buttonFunction={startOver}
              likeHistoryStep={props.data.allCellularPackagesForAccountData?.length > 1}
            />
          )}
        </div>
      );
    }
  }
  return (!props.data.isLoading || props.data.callbackRequest) && <div className='complited-container'>{getErrorPage()}</div>;
};

export default CompletedComponent;
